import { createTermTagManager } from '../../utils/createTermTagManager';

export const hiddenBaseTagManager = createTermTagManager({
  jsonQueryKey: 'is_in_hidden_base',
  label: 'Только видимые агентам',
  id: 'hiddenBase',
});
